import React, { useEffect, useState } from "react";

import BarChart from "../../../common/HorizontalBarChart";
import SummaryTable from "./SummaryTable";

const DailyReportBalance = ({ summary }) => {
  const data = [
    { label: "درآمد", color: "#075da9", value: 0 },
    { label: "مصارف", color: "#b75555", value: 0 },
  ];

  const [chartData, setChartData] = useState(data);

  useEffect(() => {
    const _data = [
      { label: "درآمد", color: "#075da9", value: summary.totalRevenue },
      { label: "مصارف", color: "#b75555", value: summary.totalExpense },
    ];

    setChartData(_data);
  }, [summary]);

  return (
    <div className="daily-report-balance-area">
      <div className="hb-chart-box">
        <BarChart data={chartData} />
      </div>
      <div className="summary-table">
        <SummaryTable data={summary} />
      </div>
    </div>
  );
};

export default DailyReportBalance;
